import React from 'react';

const StoryProgress = ({
    stories,
    currentIndex,
    currentProgress
}) => {
    console.log("StoryProgress rendering:", { storiesCount: stories?.length, currentIndex, currentProgress });
    if (!stories || stories.length === 0) return null;

    return (
        <div
            style={{
                position: 'absolute',
                top: '10px',
                left: '10px',
                right: '10px',
                zIndex: 2010,
                display: 'flex',
                gap: '4px',
                pointerEvents: 'none',
            }}
        >
            {stories.map((story, index) => (
                <div
                    key={story.id || index}
                    style={{
                        flex: 1,
                        height: '3px',
                        backgroundColor: 'rgba(255, 255, 255, 0.3)',
                        borderRadius: '2px',
                        overflow: 'hidden',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.5)'
                    }}
                >
                    <div
                        style={{
                            height: '100%',
                            width:
                                index < currentIndex
                                    ? '100%'
                                    : index === currentIndex
                                        ? `${currentProgress}%`
                                        : '0%',
                            backgroundColor: '#FFFFFF',
                            transition:
                                index === currentIndex ? 'width 0.1s linear' : 'none',
                        }}
                    />
                </div>
            ))}
        </div>
    );
};

export default StoryProgress;
